import { render, staticRenderFns } from "./UpcomingPosts.pug?vue&type=template&id=3ec60ff0&scoped=true&lang=pug&"
import script from "./UpcomingPosts.vue?vue&type=script&lang=js&"
export * from "./UpcomingPosts.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingPosts.scss?vue&type=style&index=0&id=3ec60ff0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec60ff0",
  null
  
)

export default component.exports